<template>
  <div class="warp">
    <!-- 头部工具栏 -->
    <div class="company_heard_tool">
      <el-button type="primary" size="mini" icon="el-icon-plus" @click="openDialog('添加企业')">添加</el-button>
      <el-button type="warning" size="mini" icon="el-icon-refresh" @click="refresh">刷新</el-button>
      <el-button type="success" size="mini" icon="el-icon-info" @click="getPendingList">
        <span>审核( {{ authCount.count || 0 }} )</span>
        <i v-show="authCount.loading" class="el-icon-loading" />
      </el-button>
    </div>
    <!-- 筛选 -->
    <el-form ref="screenForm" :inline="true" :model="screenForm" class="demo-form-inline">
      <el-form-item label="企业名称：" prop="companyName">
        <el-input v-model="screenForm.companyName" />
      </el-form-item>
      <el-form-item label="认证状态：" prop="auth">
        <el-select v-model="screenForm.auth" placeholder="不限" clearable>
          <el-option label="审核中" :value="0" />
          <el-option label="认证通过" :value="1" />
          <el-option label="认证失败" :value="2" />
        </el-select>
      </el-form-item>
      <el-button type="primary" size="mini" icon="el-icon-search" style="margin-right: 10px" @click="screenData">筛选</el-button>
    </el-form>
    <div ref="tableWrap" style="flex: 1">
      <el-table
        v-if="tableH"
        ref="table"
        v-loading="loading"
        :max-height="tableH - 47"
        :data="tableData"
        tooltip-effect="dark"
        :stripe="true"
        :border="true"
        size="mini"
      >
        <el-table-column type="index" label="#" />
        <el-table-column prop="name" label="营业执照">
          <template slot-scope="scope">
            <el-image :src="scope.row.businessLicense" style="width: 70px; height: 70px; border-radius: 8px" @click="previewImage(scope.row.businessLicense)" />
          </template>
        </el-table-column>
        <el-table-column label="企业名称">
          <template slot-scope="scope">
            <div>{{ scope.row.companyName }}</div>
            <div style="color: rgb(218, 205, 148)">（{{ scope.row.companyShortName }}）</div>
          </template>
        </el-table-column>
        <el-table-column prop="auth" label="认证状态">
          <template slot-scope="scope">
            <el-radio-group v-model="scope.row.auth" class="column_radio" @change="verifyCompany($event, scope.row.id)">
              <el-radio :label="0" style="color: #f7d022">审核中</el-radio>
              <el-radio :label="1" style="color: #1fe65b">认证通过</el-radio>
              <el-radio :label="2" style="color: #ee4b4b">认证拒绝</el-radio>
            </el-radio-group>
          </template>
        </el-table-column>
        <el-table-column label="上传账号">
          <template slot-scope="scope">
            {{ scope.row.uploadUsername || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="createDate" label="创建时间" />

        <el-table-column prop="address" label="操作">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" icon="el-icon-edit" @click="openDialog('编辑企业', scope.row)">编辑</el-button>
            <el-button type="danger" size="mini" icon="el-icon-delete" style="margin: 6px 0 0" @click="handleDeleteCompany(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="padding: 15px 0 0">
        <el-pagination
          :current-page="page.pageNumber"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="page.pageSize"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
    <!-- 添加 编辑对话框 -->
    <el-dialog :close-on-click-modal="false" width="800px" :title="dialogTitle" :visible.sync="showDialog" append-to-body @close="resetForm">
      <el-form ref="form" label-position="left" :rules="rules" :model="form" label-width="80px">
        <el-form-item prop="auth" label-width="100px" label="认证状态：">
          <el-radio-group v-model="form.auth">
            <el-radio :label="0">审核中</el-radio>
            <el-radio :label="1">认证通过</el-radio>
            <el-radio :label="2">认证拒绝</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="businessLicense" label-width="100px" label="营业执照">
          <el-upload
            :on-success="handleBusinessLicenseSuccess"
            :before-upload="beforeAvatarUpload"
            class="avatar-uploader"
            action="/api/admin/file/upload"
            :show-file-list="false"
          >
            <img v-if="form.businessLicense" :src="form.businessLicense" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon" />
          </el-upload>
        </el-form-item>
        <el-form-item prop="logo" label-width="100px" label="企业logo：">
          <el-upload
            :on-success="handleLogoSuccess"
            :before-upload="beforeAvatarUpload"
            class="avatar-uploader"
            action="/api/admin/file/upload"
            :show-file-list="false"
          >
            <img v-if="form.logo" :src="form.logo" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon" />
          </el-upload>
        </el-form-item>
        <el-form-item prop="companyName" label-width="100px" label="企业名称：">
          <el-input v-model="form.companyName" autocomplete="off" style="max-width: 500px" />
        </el-form-item>
        <el-form-item prop="companyShortName" label-width="100px" label="企业简名：">
          <el-input v-model="form.companyShortName" autocomplete="off" style="max-width: 200px" />
        </el-form-item>
        <el-form-item prop="attributionCompany" label-width="100px" label="归属公司：">
          <el-select v-model="form.attributionCompany" clearable filterable placeholder="请选择归属公司">
            <el-option v-for="(item, index) in attributionCompanyList" :key="index" :label="item" :value="item"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-show="dialogTitle === '编辑企业'" prop="uploadUsername" label-width="100px" label="上传账号：">
          <el-input v-model="form.uploadUsername" />
        </el-form-item>
        <!-- prop="poiAddress" -->
        <el-form-item label-width="100px" label="公司地址：">
          <div style="width: 100%; height: 100%">
            <el-input
              id="tipinput"
              v-model="inputValue"
              placeholder="搜索地名或者地址"
              prefix-icon="el-icon-search"
              class="searchInput"
              style="margin-bottom: 20px"
              @focus="isshow = true"
            />
            <div class="searchContainer">
              <div
                v-for="(item, index) in list"
                v-show="isshow"
                :key="item.id"
                class="searchItem"
                :style="activeIndex === index && 'background: #ecf5ff'"
                @click.stop="itemChange(item, index)"
              >
                <div>{{ item.name }}</div>
                <div style="color: #999; font-size: 12px">{{ item.address }}</div>
              </div>
            </div>
            <div id="map" class="map-container" style="width: 100%; height: 300px">
              <el-amap class="amap-box" vid="map'amap-vue'" :zoom="zoom" :center="mapCenter" :events="events">
                <el-amap-marker v-if="mapCenter" key="100" :position="mapCenter" />
              </el-amap>
            </div>
            <div style="width: 100%; display: flex; line-height: 40px; margin-top: 15px; justify-content: space-between">
              <div class="flex-center" style="align-self: flex-start">
                <span class="area"> <i v-show="gettingAddress" style="padding: 0 10px" class="el-icon-loading" />已选地址：</span>
              </div>
              <!-- 这个地方获取的是详细的省市区 -->
              <div style="flex: 1; display: flex; flex-wrap: wrap">
                <!-- 省 -->
                <span v-if="form.poiProvince" class="area">{{ form.poiProvince.length && form.poiProvince !== '[]' ? form.poiProvince : '-' }}</span>
                <!-- 市 -->
                <span v-if="form.poiCity" class="area">{{ form.poiCity.length && form.poiCity !== '[]' ? form.poiCity : '-' }}</span>
                <!-- 县或者区 -->
                <span v-if="form.poiDistrict != '[]'" class="area">{{ form.poiDistrict.length && form.poiDistrict !== '[]' ? form.poiDistrict : '-' }}</span>
              </div>
            </div>
          </div>
        </el-form-item>
        <el-form-item prop="introduce" label-width="100px" label="企业介绍：" style="border-top: 1px dashed #e5e5e5; padding: 15px 0">
          <el-input v-model="form.introduce" type="textarea" resize="none" />
        </el-form-item>
        <el-form-item prop="introduceImages" label-width="100px" label="企业介绍图片视频：">
          <el-upload
            :on-success="handleIntroduceSuccess"
            :before-upload="beforeImagesUpload"
            :with-credentials="true"
            action="/api/admin/file/upload"
            list-type="picture-card"
            :file-list="form.introduceImages"
            :on-remove="handleIntroduceRemove"
          >
            <i class="el-icon-plus" />
            <div slot="file" slot-scope="{ file }">
              <img v-if="isImage(file.url)" :src="file.url" style="width: 76px; height: 76px; display: block" />
              <video v-else :src="file.url" style="width: 76px; height: 76px; display: block" />
              <span class="el-upload-list__item-actions">
                <span class="el-upload-list__item-preview" @click="isImage(file.url) ? previewImage(file.url) : previewVideo(file.url)">
                  <i class="el-icon-zoom-in" />
                </span>
                <span class="el-upload-list__item-delete" @click="handleIntroduceRemove(file)">
                  <i class="el-icon-delete" />
                </span>
              </span>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item prop="fuli" label-width="100px" label="福利展示：" style="border-top: 1px dashed #e5e5e5; padding: 15px 0">
          <el-input v-model="form.fuli" type="textarea" resize="none" />
        </el-form-item>
        <el-form-item prop="fuliImages" label-width="100px" label="福利展示图片视频：">
          <el-upload
            :on-success="handleFuliSuccess"
            :before-upload="beforeImagesUpload"
            :with-credentials="true"
            action="/api/admin/file/upload"
            list-type="picture-card"
            :file-list="form.fuliImages"
            :on-remove="handleFuliRemove"
          >
            <i class="el-icon-plus" />
            <div slot="file" slot-scope="{ file }">
              <img v-if="isImage(file.url)" :src="file.url" style="width: 76px; height: 76px; display: block" />
              <video v-else :src="file.url" style="width: 76px; height: 76px; display: block" />
              <span class="el-upload-list__item-actions">
                <span class="el-upload-list__item-preview" @click="isImage(file.url) ? previewImage(file.url) : previewVideo(file.url)">
                  <i class="el-icon-zoom-in" />
                </span>
                <span class="el-upload-list__item-delete" @click="handleFuliRemove(file)">
                  <i class="el-icon-delete" />
                </span>
              </span>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item prop="jiyu" label-width="100px" label="企业寄语：" style="border-top: 1px dashed #e5e5e5; padding: 15px 0">
          <el-input v-model="form.jiyu" type="textarea" resize="none" />
        </el-form-item>
        <el-form-item prop="jiyuImages" label-width="100px" label="企业寄语图片视频：">
          <el-upload
            :on-success="handleJiyuSuccess"
            :before-upload="beforeImagesUpload"
            :with-credentials="true"
            action="/api/admin/file/upload"
            list-type="picture-card"
            :file-list="form.jiyuImages"
            :on-remove="handleJiyuRemove"
          >
            <i class="el-icon-plus" />
            <div slot="file" slot-scope="{ file }">
              <img v-if="isImage(file.url)" :src="file.url" style="width: 76px; height: 76px; display: block" />
              <video v-else :src="file.url" style="width: 76px; height: 76px; display: block" />
              <span class="el-upload-list__item-actions">
                <span class="el-upload-list__item-preview" @click="isImage(file.url) ? previewImage(file.url) : previewVideo(file.url)">
                  <i class="el-icon-zoom-in" />
                </span>
                <span class="el-upload-list__item-delete" @click="handleJiyuRemove(file)">
                  <i class="el-icon-delete" />
                </span>
              </span>
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showDialog = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit(dialogTitle === '添加企业')">提交</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="previewImageDialog">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
    <el-dialog :visible.sync="previewVideoDialog">
      <video v-if="previewVideoDialog" width="100%" :src="videoUrl" controls autoplay />
    </el-dialog>
  </div>
</template>
<script>
import pagination from '@/mixins/pagination'

export default {
  mixins: [pagination],
  data() {
    const self = this

    const addressValidator = (rule, value, cb) => {
      // poiAddress
      const { poiCity, poiDistrict, poiProvince } = self.form
      // poiAddress && poiAddress !== '[]' &&
      if (poiCity && poiCity !== '[]' && poiDistrict && poiDistrict !== '[]' && poiProvince && poiProvince !== '[]') {
        cb()
      }
      // else {
      // cb(new Error('当前地址不准确，请选择一个准确的地址'))
      // }
    }
    const imagesValidator = (rule, value, callback) => {
      if (value.length) {
        return callback()
      } else {
        callback(new Error('请至少上传一张照片或一段视频'))
      }
    }
    return {
      authCount: {
        count: 0,
        loading: true
      },
      tableH: 0,
      videoUrl: '',
      previewVideoDialog: false,
      screenForm: {
        companyName: '',
        auth: null
      },
      tableData: [],
      loading: true,
      showDialog: false,
      dialogTitle: '',
      form: {
        auth: null,
        businessLicense: '',
        logo: '',
        companyName: '',
        companyShortName: '',
        uploadUsername: '',
        poiLat: 23,
        poiLon: 113,
        poiAddress: '',
        poiCity: '',
        poiDistrict: '',
        poiProvince: '',
        businessScope: '',
        fuli: '',
        fuliImages: [],
        introduce: '',
        introduceImages: [],
        jiyu: '',
        jiyuImages: [],
        attributionCompany: ''
      },
      rules: {
        auth: [{ required: true, message: '请选择认证状态', trigger: 'change' }],
        businessLicense: [{ required: true, message: '请上传营业执照', trigger: 'change' }],
        logo: [{ required: true, message: '请上传企业logo', trigger: 'change' }],
        companyName: [{ required: true, message: '请填写企业名称', trigger: 'blur' }],
        companyShortName: [{ required: true, message: '请填写企业简称', trigger: 'blur' }],
        // poiAddress: [{ required: false, validator: addressValidator, trigger: 'change' }],
        businessScope: [{ required: true, message: '请填写经营范围', trigger: 'blur' }],
        attributionCompany: [{ required: true, message: '请选择归属公司', trigger: 'change' }]
      },
      gettingAddress: false,
      isshow: false, // 显示搜索内容
      inputValue: '', // 地图搜索
      tabIndex: '',
      list: [],
      activeIndex: '',
      zoom: 12,
      searchOption: {
        citylimit: false
      },
      location: '',
      siteDialog: false,
      primitiveData: {}, // 下方不是
      mapCenter: [113, 23],
      events: {
        // 点击获取地址的数据
        click(e) {
          const { lng, lat } = e.lnglat
          self.getAddress(lng, lat)
          console.log(lat, lng)
          self.form.poiLon = lng
          self.form.poiLat = lat
          self.mapCenter = null
          self.mapCenter = [lng, lat]
        }
      },
      attributionCompanyList: []
    }
  },
  computed: {
    introduceImages() {
      return (this.form.introduceImages || []).map((item) => {
        return {
          url: item
        }
      })
    },
    fuliImages() {
      return (this.form.fuliImages || []).map((item) => {
        return {
          url: item
        }
      })
    },
    jiyuImages() {
      return (this.form.jiyuImages || []).map((item) => {
        return {
          url: item
        }
      })
    }
  },
  watch: {
    'form.poiAddress': {
      handler(v) {
        this.form.poiAddress = v === '[]' ? '' : v
      }
    },
    siteDialog(val) {
      if (val) {
        this.inputValue = this.primitiveData.name
        this.list = []
      }
    },
    // 监听输入框是否有值
    inputValue(value) {
      if (value) {
        // 监听输入内容
        this.initMapByInput()
      }
    },
    showDialog(value) {
      if (value) {
        this.inputValue = ''
      }
    }
  },
  created() {
    this.getTableList()
  },
  mounted() {
    this.getVerifyCount()
    this.getTableList()
    this.tableH = this.$refs.tableWrap.clientHeight
    this.getAttributionCompany() // 归属公司可选范围
  },
  methods: {
    // 归属公司可选范围
    getAttributionCompany() {
      this.$api.company
        .getAttributionCompany()
        .then((res) => {
          console.log(res)
          this.attributionCompanyList = res
        })
        .catch((e) => {
          this.$message.error(e)
        })
    },
    // 地图类
    locationSure(val) {
      // 定位地址
      console.log(val)
      this.location = val.name
      this.primitiveData = val
    },
    itemChange(n, index) {
      const that = this
      that.activeIndex = index
      // 输入后搜索出来的，反地理编码出来的参数有所不同
      const lng = n.lng || n.longitude || n.location.lng
      const lat = n.lat || n.latitude || n.location.lat
      const name = n.name || ''
      console.log(n, '地里位置')
      // that.inputValue = name
      this.getAddress(lng, lat)
      that.zoom = 13
      that.form.poiLat = lat
      that.form.poiLon = lng
      that.isshow = false
    },
    initMapByInput() {
      const that = this
      // 自动搜索插件
      AMap.plugin('AMap.Autocomplete', () => {
        const autoOptions = {
          city: '全国'
        }
        const autoComplete = new AMap.Autocomplete(autoOptions)
        // 要修改
        autoComplete.search(that.inputValue, function (status, e) {
          if (status === 'complete' && e.info === 'OK') {
            if (e.tips && e.tips.length > 0) {
              const tips = e.tips.filter((i) => {
                return i.location && i.address.length > 0
              })
              const tip = tips[0]
              that.mapCenter = [tip.location.lng, tip.location.lat]
              that.zoom = 13
              that.list = tips
            } else {
              that.list = []
            }
          }
        })
      })
    },

    getTableList() {
      this.loading = true
      return this.$api.company
        .reqAllCompanyList(this.page)
        .then((res) => {
          this.tableData = res.records
          this.total = res.total
          this.loading = false
        })
        .catch(() => {})
    },
    getVerifyCount() {
      this.authCount.loading = true
      return this.$api.company
        .reqCompanyCount()
        .then((res) => {
          this.authCount.count = res
          this.authCount.loading = false
        })
        .catch((e) => {
          this.authCount.loading = false
        })
    },
    getPendingList() {
      this.$refs.screenForm.resetFields()
      this.screenForm.auth = 0
      this.screenData()
    },
    openDialog(title, row) {
      console.log(row)
      this.dialogTitle = title
      this.showDialog = true
      console.log(this.form, 56565656)
      this.form.poiCity = ''
      this.form.poiDistrict = ''
      this.form.poiLat = ''
      this.form.poiLon = ''
      this.form.poiProvince = ''
      this.mapCenter = [113, 23]
      this.zoom = 12
      if (!row) return
      this.$nextTick(() => {
        const {
          address,
          auth,
          businessLicense,
          businessScope,
          companyName,
          companyShortName,
          fuli,
          id,
          introduce,
          jiyu,
          poiLat,
          poiLon,
          poiAddress,
          poiCity,
          poiDistrict,
          poiProvince,
          logo,
          uploadUsername,
          attributionCompany
        } = row
        let { fuliImages, jiyuImages, introduceImages } = row
        fuliImages = fuliImages || []
        jiyuImages = jiyuImages || []
        introduceImages = introduceImages || []
        fuliImages = fuliImages.map((item, index) => {
          return {
            url: item,
            name: item + '' + index
          }
        })
        jiyuImages = jiyuImages.map((item, index) => {
          return {
            url: item,
            name: item + '' + index
          }
        })
        introduceImages = introduceImages.map((item, index) => {
          return {
            url: item,
            name: item + '' + index
          }
        })
        console.log('fuliImages', fuliImages)
        this.form = {
          address,
          auth,
          businessLicense,
          businessScope,
          companyName,
          companyShortName,
          fuli,
          id,
          introduce,
          jiyu,
          poiLat,
          poiLon,
          logo,
          poiAddress,
          poiCity,
          poiDistrict,
          poiProvince,
          uploadUsername,
          fuliImages: fuliImages,
          jiyuImages: jiyuImages,
          introduceImages: introduceImages,
          attributionCompany
        }
        this.inputValue = poiAddress
      })
    },
    handleSubmit(isAdd) {
      console.log(this.form)
      if (!this.validateForm()) return
      const data = {}
      Object.assign(data, this.form)
      data.fuliImages = data.fuliImages.map((item) => item.url)
      data.jiyuImages = data.jiyuImages.map((item) => item.url)
      data.introduceImages = data.introduceImages.map((item) => item.url)
      if (isAdd) {
        this.loading = true
        this.$api.company
          .reqAddCompany(data)
          .then((res) => {
            this.$message.success(res)
            this.getTableList()
            this.getVerifyCount()
            this.showDialog = false
          })
          .catch((e) => {
            this.$message.error(e)
          })
      } else {
        this.loading = true
        this.$api.company
          .reqUpdateCompany(data)
          .then((res) => {
            this.$message.success(res)
            this.getTableList()
            this.getVerifyCount()
            this.showDialog = false
          })
          .catch((e) => {
            this.$message.error(e)
          })
      }
    },
    validateForm() {
      let pass
      this.$refs.form.validate((res) => {
        pass = res
      })
      return pass
    },
    verifyCompany(auth, id) {
      this.loading = true
      this.$api.company
        .reqUpdateCompanyAuth({ auth, id })
        .then((res) => {
          this.loading = false
          this.getVerifyCount()
          this.$message.success('操作成功')
        })
        .catch((e) => {
          this.getTableList()
          this.$message.error(e)
        })
    },
    handleDeleteCompany(row) {
      this.$confirm('此操作将永久删除该企业, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.loading = true
          this.$api.company
            .reqDeleteCompany({ ids: row.id })
            .then((res) => {
              this.$message({
                type: 'success',
                message: res
              })
              this.loading = true
              this.getTableList()
              this.getVerifyCount()
            })
            .catch((e) => {
              this.$message({
                type: 'info',
                message: e
              })
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    beforeAvatarUpload(file) {
      const isImg = /image/.test(file.type)
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isImg) {
        this.$message.error('上传头像图片只能是 JPG 或 PNG 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isImg && isLt2M
    },
    // 这个是接口？、
    getAddress(lon, lat) {
      if (this.gettingAddress) return
      this.gettingAddress = true
      this.$api.common
        .reqGeocoder({ lat, lon })
        .then((res) => {
          console.log(res, 55656565)
          this.inputValue = res.address
          this.form.poiAddress = res.address
          this.form.poiCity = res.city
          this.form.poiDistrict = res.district
          this.form.poiProvince = res.province
          this.gettingAddress = false
        })
        .catch(() => (this.gettingAddress = false))
        .finally(() => {
          if (
            this.form.poiAddress &&
            this.form.poiAddress !== '[]' &&
            this.form.poiCity &&
            this.form.poiCity !== '[]' &&
            this.form.poiDistrict &&
            this.form.poiDistrict !== '[]' &&
            this.form.poiProvince &&
            this.form.poiProvince !== '[]'
          ) {
            this.$refs.form.clearValidate('poiAddress')
          } else {
            this.$refs.form.validateField('poiAddress')
          }
        })
    },
    beforeImagesUpload(file) {
      const isImg = /image/.test(file.type)
      const isVideo = /video/.test(file.type)
      if (!isImg && !isVideo) {
        this.$message.error('只能上传图片或者视频')
      }
      return isImg || isVideo
    },
    handleBusinessLicenseSuccess(res) {
      this.$refs.form.clearValidate('businessLicense')
      this.form.businessLicense = res.data
    },
    handleLogoSuccess(res) {
      this.$refs.form.clearValidate('logo')
      this.form.logo = res.data
    },
    handleIntroduceSuccess(res, file, filelist) {
      console.log(res, file, filelist)
      file.url = res.data
      this.form.introduceImages = [...this.form.introduceImages, file]
      this.$refs.form.clearValidate('introduceImages')
    },
    handleFuliSuccess(res, file) {
      file.url = res.data
      this.form.fuliImages = [...this.form.fuliImages, file]
      this.$refs.form.clearValidate('fuliImages')
    },
    handleJiyuSuccess(res, file) {
      file.url = res.data
      this.form.jiyuImages = [...this.form.jiyuImages, file]
      this.$refs.form.clearValidate('jiyuImages')
      console.log(file)
    },
    handleIntroduceRemove(file) {
      this.form.introduceImages = this.form.introduceImages.filter((item) => item.url !== file.url)
      this.form.jiyuImages.length || this.$refs.form.validateField('introduceImages')
    },
    handleFuliRemove(file) {
      console.log(this.form.fuliImages)
      this.form.fuliImages = this.form.fuliImages.filter((item) => item.url !== file.url)
      this.form.jiyuImages.length || this.$refs.form.validateField('fuliImages')
    },
    handleJiyuRemove(file) {
      this.form.jiyuImages = this.form.jiyuImages.filter((item) => item.url !== file.url)
      this.form.jiyuImages.length || this.$refs.form.validateField('jiyuImages')
    },
    resetForm() {
      this.$refs.form.resetFields()
    },
    refresh() {
      this.page = {
        pageNumber: 1,
        pageSize: 10
      }
      this.$refs.screenForm.resetFields()
      Promise.all([this.reqCompanyCount(), this.getTableList()])
        .then(() => {
          this.loading = false
          this.authCount.loading = false
        })
        .catch(() => {})
    },
    reqCompanyCount() {
      this.authCount.loading = true
      return this.$api.company
        .reqCompanyCount()
        .then((res) => {
          this.authCount.count = res
          this.authCount.loading = false
        })
        .catch((e) => {
          this.authCount.loading = false
        })
    },
    screenData() {
      this.page = {
        pageNumber: 1,
        pageSize: 10
      }
      Object.assign(this.page, this.screenForm)
      Promise.all([this.getVerifyCount(), this.getTableList()])
        .then(() => {
          this.loading = false
          this.authCount.loading = false
        })
        .catch(() => {})
    },
    isImage(url) {
      const imglist = ['png', 'jpg', 'jpeg', 'bmp', 'gif']
      let format = url.split('.')
      format = format[format.length - 1]
      if (imglist.some((item) => item === format)) {
        return true
      } else {
        return false
      }
    },
    previewVideo(url) {
      this.videoUrl = url
      this.previewVideoDialog = true
    }
  }
}
</script>
<style lang="scss" scoped>
.warp {
  font-size: 14px;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: calc(100vh - 84px);
  .company_heard_tool {
    margin-bottom: 10px;
  }
  .flex-center {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.area {
  width: max-content;
  padding: 0 10px;
  margin: 0 5px;
  border-radius: 10rpx;
  background-color: #f2f2f2;
  color: #666;
  margin-bottom: 15px;
}
/*地图类*/
.amap-demo {
  width: 100%;
  height: 600px;
  position: relative;
}

.search-box {
  height: 35px;
  margin: 10px auto;
  width: calc(100% - 20px);
  // border-radius:16px;
  box-shadow: none;
  background: #ffff;
  border: 1px solid #e6e6e6;

  .search-box-wrapper {
    input {
      background: #fff;
      padding-left: 20px;
    }

    .search-btn {
      color: #2a67fe;
      width: 90px;
      height: 20px;
      box-sizing: border-box;
      border-left: 1px solid #d7d7d7;
    }
  }
}
</style>
